module.exports = __webpack_public_path__ + "static/img/6.4cb158e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/6.png
// module id = gR1Z
// module chunks = 0